export default __webpack_public_path__ + "static/media/foto8_pexels-marta-ortigosa-3480494.68a1ad02.jpg";